import React from 'react';
import './index.scss';
import {ReactComponent as Mail} from 'assets/parts_mail.svg';

const SpFinishContact = ({
  info,
}) => {

  const DispInfo = () => {
    return Array.isArray(info)
      ? info.map(line => (
        <div key={line} className="mB20">
          {line}
        </div>
      ))
      : <>{info}</>;
  };

  return (
    <div className="SpFinishContact">
      <div className="info">
        <DispInfo />
      </div>
      <div className="mailArea">
        <Mail height='12px' />
        <label className="mail">tokatu@r-staffing.co.jp</label>
      </div>
    </div>
  );
};

export default SpFinishContact;